import { useState } from 'react';
import { DateTime } from 'luxon';

const slotToTime = slot => {
    if (slot === 96) {
        return '24:00';
    }
    const hours = Math.floor(slot / 4);
    const minutes = (slot % 4) * 15;
    return DateTime.fromObject({ hour: hours, minute: minutes }).toFormat('HH:mm');
};

const DailyScheduleSummaryTable = ({ title, dayData, modes }) => {
    const [collapsed, setCollapsed] = useState(true);

    const blocks = [];
    let current = null;

    for (let i = 0; i < 96; i++) {
        const slot = dayData?.slots?.[i];
        if (!slot) {
            continue;
        }

        if (!current) {
            current = { mode: slot.mode, config: slot.config, start: i, end: i };
        } else if (slot.mode === current.mode) {
            current.end = i;
        } else {
            blocks.push(current);
            current = { mode: slot.mode, config: slot.config, start: i, end: i };
        }
    }
    if (current) {
        blocks.push(current);
    }

    const getModeName = id => {
        if (id === 0) {
            return 'idle';
        }
        const rawName = modes.find(m => m.id === id)?.name || 'Unknown';
        return formatKeyLabel(rawName);
    };

    const formatKeyLabel = key => key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

    return (
        <div className="daily-schedule-summary-table">
            <div className="daily-schedule-summary-table__header" onClick={() => setCollapsed(!collapsed)}>
                <div className="daily-schedule-summary-table__title">{title}</div>
                <div className="daily-schedule-summary-table__collapse">
                    <i className={`fa ${collapsed ? 'fa-chevron-right' : 'fa-chevron-down'}`} />
                </div>
            </div>
            {!collapsed && (
                <table className="daily-schedule-summary-table__table">
                    <thead>
                        <tr>
                            <th>From</th>
                            <th>To</th>
                            <th>Mode</th>
                            <th>Config</th>
                        </tr>
                    </thead>
                    <tbody>
                        {blocks.map((block, idx) => (
                            <tr key={idx}>
                                <td>{slotToTime(block.start)}</td>
                                <td>{slotToTime(block.end + 1)}</td>
                                <td>{getModeName(block.mode)}</td>
                                <td className="daily-schedule-summary-table--config">
                                    {block.config && Object.keys(block.config).length > 0 ? (
                                        <div className="daily-schedule-summary-table__table--config--details">
                                            {Object.entries(block.config)
                                                .filter(([key]) => key.toLowerCase() !== 'mode')
                                                .map(([key, value]) => (
                                                    <div key={key} style={{ breakInside: 'avoid' }}>
                                                        <strong>{formatKeyLabel(key)}</strong>:{' '}
                                                        {value === null || value === undefined ? (
                                                            <span className="daily-schedule-summary-table--config--no-data">Not set</span>
                                                        ) : (
                                                            String(value)
                                                        )}
                                                    </div>
                                                ))}
                                        </div>
                                    ) : (
                                        <span className="daily-schedule-summary-table--config--no-data">–</span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default DailyScheduleSummaryTable;
